import * as React from 'react';

import * as Sentry from '@sentry/browser';
import { translate } from '~l10n/client';
import Provider from 'react-redux/es/components/Provider';

import store from '../../src/store';

export class ErrorView extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope((scope) => {
      Object.keys(errorInfo).forEach((key) => {
        scope.setExtra(key, errorInfo[key]);
      });
      Sentry.captureException(error);
    });

    this.setState({ hasError: true });
  }

  render() {
    if (!this.state.hasError) {
      return <Provider store={store}>{this.props.children}</Provider>;
    }

    return (
      <Provider store={store}>
        <div className="errorView">
          <h2>{translate('Hmm, something unexpected happened.')}</h2>
          <div>
            {translate(
              'Please refresh and try again. If problems persist, don’t hesitate to contact us for help!'
            )}
          </div>
          <button
            className="button button-primary button-small"
            onClick={this.onRefreshClick}
          >
            {translate('Refresh')}
          </button>
        </div>
      </Provider>
    );
  }

  onRefreshClick() {
    window.location.reload();
  }
}
